import { tracker } from '@lessonup/analytics';
import { teacherTeachUrl } from '@lessonup/typescript-core/services';
import { Button, Heading, RocketSvg, useBEM } from '@lessonup/typescript-core/ui';
import { ImageUtils } from '@lessonup/typescript-core/utils';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { RegistrationFormProps } from '../../types';
import { useRegistrationContext } from '../../utils/RegistrationContext';
import './RegistrationDemoLessonPage.less';

type Props = RegistrationFormProps;

export const TRANSLATION_NAMESPACE = 'registrationDemoLessonPage';

export const RegistrationDemoLessonPage: React.FC<Props> = (props) => {
  const bemClasses = useBEM('RegistrationDemoLessonPage');
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  const { demoLesson } = useRegistrationContext();

  useEffect(() => {
    tracker.events.onboardingLessonDemoPrompted();
  }, []);

  const imageUrl = ImageUtils.checkImageUrl(demoLesson?.thumbnail?.url);

  return (
    <div className={bemClasses()}>
      <div className={bemClasses({ element: 'col' })}>
        <div className={bemClasses({ element: 'description' })}>
          <Heading as="h1" className={bemClasses({ element: 'title' })}>
            {t('title')}
          </Heading>
          <p>{t('description')}</p>
        </div>
        <div className={bemClasses({ element: 'button-container' })}>
          <Button
            theme="secondary"
            height="medium"
            version="modern"
            onClick={
              demoLesson?.id
                ? () => window.open(teacherTeachUrl({ lessonId: demoLesson.id, source: 'onboarding-demo' }), '_self')
                : props.next
            }
          >
            {t('startLesson')}
          </Button>
          <Button theme="transparent" height="medium" version="modern" onClick={() => props.next()}>
            {t('skip')}
          </Button>
        </div>
        <div className={bemClasses({ element: 'extra-text' })}>
          <span>
            <Trans t={t} i18nKey="extraText" />
          </span>
        </div>
      </div>
      <div className={bemClasses({ element: 'col' })}>
        {imageUrl ? (
          <div className={bemClasses({ element: 'img-container' })} style={{ backgroundImage: `url(${imageUrl})` }} />
        ) : (
          <div className={bemClasses({ element: 'img-container', modifier: 'placeholder' })}>
            <RocketSvg className={bemClasses({ element: 'placeholder-svg' })} />
          </div>
        )}
      </div>
    </div>
  );
};
